<template>
  <div class="page-container">
    <div class="page-content">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-account-tie"></i> Corretores
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <button class="btn btn-outline-white" @click="openCreateBrokerModal()">
              <i class="fas fa-plus"></i> Nova Corretora
            </button>
            <button class="btn btn-outline-white" @click="openExportModal()">
              <i class="mdi mdi-file-excel-box"></i> Exportar
            </button>
          </div>
        </div>
      </div>

      <!-- Alertas -->
      <div v-if="alertMessage" class="col-12 mb-2">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="overlay d-flex align-items-center justify-content-center mb-3">
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <!-- Card com Tabela -->
      <div class="card bg-light-gray">
        <div class="card-body pt-1">
          <div class="table-responsive">
            <table class="table-v3 w-100" role="table" aria-busy="false">
              <thead role="rowgroup">
                <tr role="row">
                  <th class="nowrap">Corretora</th>
                  <th class="nowrap">CNPJ</th>
                  <th class="nowrap text-center">Ações</th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr v-for="(broker, idx) in paginatedItems" :key="idx" role="row">
                  <td role="cell" class="font-12">{{ broker.name }}</td>
                  <td role="cell" class="font-12">{{ broker.cnpj | formatDocument }}</td>
                  <td role="cell" class="font-12 text-center">
                    <button class="btn btn-action" @click="openEditBrokerModal(broker.id)" v-b-tooltip.hover
                      title="Editar Corretora">
                      <i class="fas fa-edit"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginação 3 números + setas -->
          <nav aria-label="Paginação" class="mt-3">
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>
              <li v-for="p in pages" :key="p" class="page-item" :class="{ active: p === currentPage }">
                <a class="page-link" href="#" @click.prevent="changePage(p)">{{ p }}</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <!-- Modais inalterados -->
    <b-modal id="modal-edit-broker" ref="modalEditBroker" size="md" hide-footer centered class="mt-4">
      <template #modal-title>
        <h5 class="modal-title">Editar Corretora</h5>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-content border-0">
          <div class="modal-body">
            <!-- Campos e validações mantidos -->
            <validation-provider name="Nome" rules="required|max:255" v-slot="{ valid, errors }">
              <b-form-group label="Nome da Corretora">
                <b-form-input v-model="form.name" :state="valid" placeholder="Digite o nome da corretora" />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider name="CNPJ" rules="required|cnpj_format" v-slot="{ valid, errors }">
              <b-form-group label="CNPJ">
                <b-form-input v-model="form.cnpj" :state="valid" placeholder="Digite o CNPJ"
                  v-mask="'XX.XXX.XXX/XXXX-##'" />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="modal-footer">
            <b-button variant="secondary" @click="$bvModal.hide('modal-edit-broker')">
              <i class="fa fa-times mr-1"></i>Cancelar
            </b-button>
            <b-button variant="primary" @click="handleSubmit(submitEditBroker)">
              <i class="fa fa-save mr-1"></i>Salvar
            </b-button>
          </div>
        </div>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-create-broker" ref="modalCreateBroker" size="md" hide-footer centered class="mt-4">
      <template #modal-title>
        <h5 class="modal-title">Nova Corretora</h5>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-content border-0">
          <div class="modal-body">
            <!-- Mesmos campos de criação -->
            <validation-provider name="Nome" rules="required|max:255" v-slot="{ valid, errors }">
              <b-form-group label="Nome da Corretora">
                <b-form-input v-model="form.name" :state="valid" placeholder="Digite o nome da corretora" />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider name="CNPJ" rules="required|cnpj_format" v-slot="{ valid, errors }">
              <b-form-group label="CNPJ">
                <b-form-input v-model="form.cnpj" :state="valid" placeholder="Digite o CNPJ"
                  v-mask="'XX.XXX.XXX/XXXX-##'" />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="modal-footer">
            <b-button variant="secondary" @click="$bvModal.hide('modal-create-broker')">
              <i class="fa fa-times mr-1"></i>Cancelar
            </b-button>
            <b-button variant="primary" @click="handleSubmit(submitBroker)">
              <i class="fa fa-save mr-1"></i>Salvar
            </b-button>
          </div>
        </div>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-export-broker" ref="modalExportBroker" size="md" hide-footer centered class="mt-4">
      <template #modal-title>
        <h5 class="modal-title">Exportar Apólices</h5>
      </template>
      <div class="modal-content border-0">
        <div class="modal-body">
          <b-form-group label="Selecione a Corretora">
            <b-form-select v-model="selectedBrokerForExport">
              <b-form-select-option :value="null">Todas as Corretoras</b-form-select-option>
              <b-form-select-option v-for="broker in items" :key="broker.id" :value="broker.id">
                {{ broker.name }} – {{ broker.cnpj | formatDocument }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="modal-footer">
          <b-button variant="secondary" @click="$bvModal.hide('modal-export-broker')">
            <i class="fa fa-times mr-1"></i>Cancelar
          </b-button>
          <b-button variant="primary" @click="exportPoliciesToExcel()">
            <i class="fa fa-file-export mr-1"></i>Exportar
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import brokerService from "@/services/broker";
import dateFormatter from "@/mixins/dateFormatter";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mask } from "vue-the-mask";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { extend } from "vee-validate";
import { isValidCnpj, sanitizeDocument } from "@/utils/document";

extend("cnpj_format", {
  message: "CNPJ inválido.",
  validate: value => isValidCnpj(value)
});


export default {
  name: "list-brokers",
  mixins: [dateFormatter],
  directives: {
    mask,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    loading: false,
    broker: {},
    selectedBrokerForExport: null,
    exportStartDate: null,
    exportEndDate: null,
    form: {
      id: null,
      name: '',
      cnpj: '',
    },
  }),
  created() {
    this.getBrokers();
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.items.length / this.perPage));
    },
    pages() {
      const t = this.totalPages;
      if (t <= 3) return Array.from({ length: t }, (_, i) => i + 1);
      if (this.currentPage === 1) return [1, 2, 3];
      if (this.currentPage === t) return [t - 2, t - 1, t];
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.items.slice(start, start + this.perPage);
    },
    documentMask() {
      return ["XX.XXX.XXX/XXXX-##"];
    },
  },
  methods: {
    openExportModal() {
      this.selectedBrokerForExport = null;
      this.exportStartDate = null;
      this.exportEndDate = null;
      this.$bvModal.show("modal-export-broker");
    },
    exportPoliciesToExcel() {
      this.loading = true;
      const payload = {
        broker_ids: this.selectedBrokerForExport ? [this.selectedBrokerForExport] : [],
        start_date: this.exportStartDate,
        end_date: this.exportEndDate,
      };

      brokerService.exportPolicies(payload)
        .then((response) => {
          const rows = response.data.map((item) => ({
            "Número da Apólice": item.number,
            "Tomador": item.policy_holder_name,
            "Segurado": item.insured_name,
            "Valor da Cobertura": item.coverage_value,
            "Prêmio": item.insurance_premium,
            "Início Vigência": item.validity_start,
            "Fim Vigência": item.validity_expiration,
            "Produto": item.insurance_type || '',
            "Corretora": item.broker,
            "ID Corretora": item.broker_id,
            "Data de Criação": item.created_at,
          }));

          const ws = XLSX.utils.json_to_sheet(rows);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Apólices");

          const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const blob = new Blob([wbout], { type: "application/octet-stream" });
          saveAs(blob, `policies_export_${Date.now()}.xlsx`);
        })
        .catch(() => {
          this.$bvToast.toast("Não foi possível exportar as apólices.", {
            title: "Erro",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.$bvModal.hide("modal-export-broker");
        });
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    openEditBrokerModal(brokerId) {
      brokerService.show(brokerId).then((response) => {
        const broker = response.data;
        this.form.id = broker.id;
        this.form.name = broker.name;
        this.form.cnpj = broker.cnpj;
        this.$bvModal.show("modal-edit-broker");
      });
    },
    openCreateBrokerModal() {
      this.resetForm();
      this.$bvModal.show("modal-create-broker");
    },
    submitBroker() {
      const payload = {
        ...this.form,
        cnpj: sanitizeDocument(this.form.cnpj),
      };
      brokerService.create(payload).then(() => {
        this.getBrokers();
        this.$bvModal.hide("modal-create-broker");
      });
    },

    submitEditBroker() {
      const payload = {
        ...this.form,
        cnpj: sanitizeDocument(this.form.cnpj),
      };
      brokerService.update(this.form.id, payload).then(() => {
        this.getBrokers();
        this.$bvModal.hide("modal-edit-broker");
      });
    },
    resetForm() {
      this.form = {
        id: null,
        name: '',
        cnpj: '',
      };
    },
    getBrokers() {
      this.loading = true;
      brokerService
        .get()
        .then((response) => {
          if (response.data.error) {
            console.error(response);
            return;
          }
          this.items = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os corretores.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params: params });
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
  },
};
</script>

<style scoped>
/* Adicione estilos se necessário */
</style>
